import IconCollapseAll from "../../../../../components/icons/icon-callapse-all/icon-callapse-all";
import { ButtonIcon } from "../../../../../components/inputs/button-icon/button-icon";
import DashTranslation from "../../../../../dashboard-translation/dashboard-translaton";
import "./expand-collapse-all.scss";

interface IProps {
    isExpanded: boolean;
    onClick?: () => void;
}
const ExpandCollapseAll: React.FC<IProps> = ({ isExpanded, onClick }) => {
    const title = isExpanded ? 'COLLAPSE_ALL' : 'EXPAND_ALL';
    return <div onClick={onClick} className={`expand-callapse-all ${isExpanded ? 'expanded' : ''}`}>
        <DashTranslation translationKey={title} scope="dashboard-general" />
        <ButtonIcon Component={IconCollapseAll} onClick={onClick} />
    </div>
}

export default ExpandCollapseAll;
